export enum ChatMessageSender {
    BOT = 'bot',
    LEAD = 'lead'
}